import * as React from "react";
import { InputProps } from "./form";
import { Autocomplete as MuiAutocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { Eq } from "fp-ts/Eq";
import {
    AutocompleteOwnerState,
    AutocompleteRenderGetTagProps,
} from "@mui/material/Autocomplete/Autocomplete";

interface Props<Option> extends InputProps {
    label: React.ReactNode;
    options: Array<Option>;
    getOptionLabel: (o: Option) => string;
    optionEq: Eq<Option>;
    multiple?: boolean;
    fullWidth?: boolean;
    loading?: boolean;
    renderTags?: (
        value: Option[],
        getTagProps: AutocompleteRenderGetTagProps
    ) => React.ReactNode;
}

function AutocompleteInner<Option>(
    p: Props<Option>,
    _ref: React.ForwardedRef<HTMLDivElement>
) {
    const defaultValue = React.useMemo(
        () => (p.multiple ? [] : null),
        [p.multiple]
    );

    return (
        <Controller
            name={p.name}
            control={p.control}
            render={({ field }) => (
                <MuiAutocomplete
                    loading={p.loading}
                    multiple={p.multiple}
                    value={field.value || defaultValue}
                    filterSelectedOptions
                    getOptionLabel={p.getOptionLabel}
                    isOptionEqualToValue={p.optionEq.equals}
                    options={p.options}
                    onChange={(event, newVal) => {
                        field.onChange(newVal);
                    }}
                    renderTags={p.renderTags}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            required={p.required}
                            helperText={p.helperText}
                            error={p.error}
                            label={p.label}
                        />
                    )}
                />
            )}
        />
    );
}

export const Autocomplete = React.forwardRef(AutocompleteInner);
